import { Component, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { ActivatedRoute, Router } from '@angular/router';
import * as _ from 'lodash';
import { GroupService } from 'shared/services/SS-Groups/groups.service';
import { AlertPopupService } from 'shared/services/SS-Alert/alert-popup.service';
import { DataSharingService } from 'shared/services/data-sharing/data-sharing.service';
import { SsOnboardingService } from 'shared/services/SS-Onboard/ss-onboarding.service';
import { Inject } from '@angular/core';
import { UserService } from 'shared/services/User/user.service';

@Component({
  selector: 'app-seat-view-modal',
  templateUrl: './seat-view-modal.component.html',
  styleUrls: ['./seat-view-modal.component.css']
})
export class SeatViewModal implements OnInit {

  seatViewURL = 'http://spurs.io-media.com/#/vr/Section/102/21/3/d#venueViewHolder';

  constructor(
    public dialogRef: MatDialogRef<SeatViewModal>,
    private router: Router,
    private groupService: GroupService,
    private alertService: AlertPopupService,
    private data: DataSharingService,
    private onboarding: SsOnboardingService,
    private us: UserService,
    @Inject(MAT_DIALOG_DATA) private params: any
  ) {
    console.log("------ HERE ----- ")
    // this.seatViewURL =  this.params.seatViewURL;
    console.log(this.seatViewURL)
  }

  ngOnInit() {

  }
}



// WEBPACK FOOTER //
// ./src/app/shared/reusable/seat-view-modal/seat-view-modal.component.ts